import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/external-link-blue.svg'
import _imports_1 from '@/assets/wikidata.png'


const _hoisted_1 = { class: "details-card" }
const _hoisted_2 = { class: "details-text" }
const _hoisted_3 = { class: "attribution-container attribution-with-legend" }
const _hoisted_4 = {
  key: 0,
  class: "attribution-spacing"
}
const _hoisted_5 = { class: "legend-icon" }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_8 = { class: "date-container" }
const _hoisted_9 = { class: "wrap-text" }
const _hoisted_10 = { class: "note-container" }
const _hoisted_11 = { class: "wrap-text" }
const _hoisted_12 = ["href", "title"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "attribution-image",
  src: _imports_1
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "details-image" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  src: "https://plugin.lincsproject.ca/cidoc-images/person.svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.legendIcon != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.legendIcon), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("a", {
          href: _ctx.externalUrl,
          class: "wrap-text details-card-link",
          target: "_blank"
        }, [
          _createTextVNode(_toDisplayString(_ctx.person?.objectLabel ?? _ctx.person?.object) + " ", 1),
          _hoisted_7
        ], 8, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, [
          (_ctx.showProperty(_ctx.person?.birthDate))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.convertDateStrings(_ctx.person?.birthDate?.object) ?? ""), 1)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.showProperty(_ctx.person?.birthDate) && _ctx.showProperty(_ctx.person?.deathDate) && _ctx.convertDateStrings(_ctx.person?.birthDate?.object) && _ctx.convertDateStrings(_ctx.person?.deathDate?.object))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" - ")
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.showProperty(_ctx.person?.deathDate))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(_toDisplayString(_ctx.convertDateStrings(_ctx.person?.deathDate?.object) ?? ""), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, [
          (_ctx.showProperty(_ctx.person?.description))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.person?.description?.object ?? ""), 1)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.person.hasOwnProperty('wikidataAttribution') && _ctx.showWikidataAttribution)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "attribution-container",
                href: _ctx.person?.wikidataAttribution,
                target: "_blank",
                title: _ctx.person?.wikidataAttribution
              }, _hoisted_14, 8, _hoisted_12))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_ctx.showProperty(_ctx.person?.image) && _ctx.person?.image?.object)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.person?.image?.object
          }, null, 8, _hoisted_16))
        : (_openBlock(), _createElementBlock("img", _hoisted_17))
    ])
  ]))
}